function generateRandom(length) {
  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
  var result = '';
  var arr = new Uint8Array(length || 64);
  crypto.getRandomValues(arr);
  arr.forEach(function(b) { result += chars[b % chars.length]; });
  return result;
}
async function sha256base64url(plain) {
  var encoder = new TextEncoder();
  var data = encoder.encode(plain);
  var hash = await crypto.subtle.digest('SHA-256', data);
  return btoa(String.fromCharCode(...new Uint8Array(hash))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
async function initiateLogin() {
  var verifier = generateRandom(64);
  var challenge = await sha256base64url(verifier);
  var state = generateRandom(32);
  var nonce = generateRandom(16);
  sessionStorage.setItem('pkce_verifier', verifier);
  sessionStorage.setItem('oauth_state', state);
  var params = new URLSearchParams({ client_id: SHOPIFY_CONFIG.clientId, response_type: 'code', redirect_uri: SHOPIFY_CONFIG.redirectUri, scope: SHOPIFY_CONFIG.scopes, state: state, nonce: nonce, code_challenge: challenge, code_challenge_method: 'S256' });
  window.location.href = SHOPIFY_CONFIG.authEndpoint + '?' + params.toString();
}
async function exchangeCodeForToken(code) {
  var verifier = sessionStorage.getItem('pkce_verifier');
  sessionStorage.removeItem('pkce_verifier');
  sessionStorage.removeItem('oauth_state');
  var body = new URLSearchParams({ grant_type: 'authorization_code', client_id: SHOPIFY_CONFIG.clientId, redirect_uri: SHOPIFY_CONFIG.redirectUri, code: code, code_verifier: verifier });
  var res = await fetch(SHOPIFY_CONFIG.tokenEndpoint, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: body.toString() });
  if (!res.ok) throw new Error('Token exchange failed');
  return await res.json();
}
async function handleLogout() {
  var idToken = localStorage.getItem('ca_id_token') || '';
  localStorage.removeItem('ca_access_token');
  localStorage.removeItem('ca_refresh_token');
  localStorage.removeItem('ca_expires_at');
  localStorage.removeItem('ca_id_token');
  var params = new URLSearchParams({ id_token_hint: idToken, post_logout_redirect_uri: SHOPIFY_CONFIG.redirectUri });
  window.location.href = SHOPIFY_CONFIG.logoutEndpoint + '?' + params.toString();
}
function getAccessToken() {
  var token = localStorage.getItem('ca_access_token');
  var expiresAt = parseInt(localStorage.getItem('ca_expires_at') || '0');
  if (!token || Date.now() > expiresAt) return null;
  return token;
}
async function caFetch(query, variables) {
  var token = getAccessToken();
  if (!token) { initiateLogin(); return null; }
  var res = await fetch(SHOPIFY_CONFIG.apiEndpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': token }, body: JSON.stringify({ query: query, variables: variables || {} }) });
  if (res.status === 401) { initiateLogin(); return null; }
  var json = await res.json();
  if (json.errors) throw new Error(json.errors.map(function(e) { return e.message; }).join(', '));
  return json.data;
}
var GET_CUSTOMER = '\n  query {\n    customer {\n      id firstName lastName\n      emailAddress { emailAddress }\n      phoneNumber { phoneNumber }\n      defaultAddress { id firstName lastName company address1 address2 city province zip country }\n      addresses(first: 10) { nodes { id firstName lastName company address1 address2 city province zip country } }\n      metafield(namespace: "custom", key: "vat_tax_number") { value }\n      orders(first: 10, sortKey: PROCESSED_AT, reverse: true) {\n        pageInfo { hasNextPage endCursor }\n        nodes {\n          id name processedAt financialStatus fulfillmentStatus\n          totalPrice { amount currencyCode }\n          subtotal { amount currencyCode }\n          totalShipping { amount currencyCode }\n          totalTax { amount currencyCode }\n          fulfillments(first: 1) { nodes { trackingInformation { number url company } } }\n          lineItems(first: 10) { nodes { id title quantity variantTitle price { amount currencyCode } image { url altText } } }\n          shippingAddress { firstName lastName address1 address2 city province zip country }\n        }\n      }\n      orderStats: orders(first: 250, sortKey: PROCESSED_AT, reverse: true) {\n        nodes { totalPrice { amount currencyCode } }\n      }\n    }\n  }\n';
var LOAD_MORE_ORDERS = '\n  query loadMoreOrders($after: String!) {\n    customer {\n      orders(first: 10, after: $after, sortKey: PROCESSED_AT, reverse: true) {\n        pageInfo { hasNextPage endCursor }\n        nodes {\n          id name processedAt financialStatus fulfillmentStatus\n          totalPrice { amount currencyCode }\n          subtotal { amount currencyCode }\n          totalShipping { amount currencyCode }\n          totalTax { amount currencyCode }\n          fulfillments(first: 1) { nodes { trackingInformation { number url company } } }\n          lineItems(first: 10) { nodes { id title quantity variantTitle price { amount currencyCode } image { url altText } } }\n          shippingAddress { firstName lastName address1 address2 city province zip country }\n        }\n      }\n    }\n  }\n';
var UPDATE_CUSTOMER = '\n  mutation customerUpdate($input: CustomerUpdateInput!) {\n    customerUpdate(input: $input) {\n      customer { id firstName lastName phoneNumber { phoneNumber } }\n      userErrors { field message }\n    }\n  }\n';
var UPDATE_METAFIELD = '\n  mutation metafieldsSet($metafields: [MetafieldsSetInput!]!) {\n    metafieldsSet(metafields: $metafields) {\n      metafields { key value }\n      userErrors { field message }\n    }\n  }\n';
var CREATE_ADDRESS = '\n  mutation customerAddressCreate($address: CustomerAddressInput!) {\n    customerAddressCreate(address: $address) {\n      customerAddress { id }\n      userErrors { field message }\n    }\n  }\n';
var UPDATE_ADDRESS = '\n  mutation customerAddressUpdate($addressId: ID!, $address: CustomerAddressInput!, $defaultAddress: Boolean) {\n    customerAddressUpdate(addressId: $addressId, address: $address, defaultAddress: $defaultAddress) {\n      customerAddress { id }\n      userErrors { field message }\n    }\n  }\n';
var DELETE_ADDRESS = '\n  mutation customerAddressDelete($addressId: ID!) {\n    customerAddressDelete(addressId: $addressId) {\n      deletedAddressId\n      userErrors { field message }\n    }\n  }\n';
var COUNTRIES = [
  ['AF','Afghanistan'],['AL','Albania'],['DZ','Algeria'],['AD','Andorra'],['AO','Angola'],
  ['AI','Anguilla'],['AG','Antigua & Barbuda'],['AR','Argentina'],['AM','Armenia'],['AW','Aruba'],
  ['AU','Australia'],['AT','Austria'],['AZ','Azerbaijan'],['BS','Bahamas'],['BH','Bahrain'],
  ['BD','Bangladesh'],['BB','Barbados'],['BY','Belarus'],['BE','Belgium'],['BZ','Belize'],
  ['BJ','Benin'],['BM','Bermuda'],['BT','Bhutan'],['BO','Bolivia'],['BA','Bosnia & Herzegovina'],
  ['BW','Botswana'],['BR','Brazil'],['BN','Brunei'],['BG','Bulgaria'],['BF','Burkina Faso'],
  ['BI','Burundi'],['KH','Cambodia'],['CM','Cameroon'],['CA','Canada'],['CV','Cape Verde'],
  ['KY','Cayman Islands'],['CF','Central African Republic'],['TD','Chad'],['CL','Chile'],['CN','China'],
  ['CO','Colombia'],['KM','Comoros'],['CD','Congo (DRC)'],['CG','Congo'],['CR','Costa Rica'],
  ['CI',"Cote d'Ivoire"],['HR','Croatia'],['CU','Cuba'],['CW','Curacao'],['CY','Cyprus'],
  ['CZ','Czechia'],['DK','Denmark'],['DJ','Djibouti'],['DM','Dominica'],['DO','Dominican Republic'],
  ['EC','Ecuador'],['EG','Egypt'],['SV','El Salvador'],['GQ','Equatorial Guinea'],['ER','Eritrea'],
  ['EE','Estonia'],['SZ','Eswatini'],['ET','Ethiopia'],['FK','Falkland Islands'],['FO','Faroe Islands'],
  ['FJ','Fiji'],['FI','Finland'],['FR','France'],['GF','French Guiana'],['PF','French Polynesia'],
  ['GA','Gabon'],['GM','Gambia'],['GE','Georgia'],['DE','Germany'],['GH','Ghana'],
  ['GI','Gibraltar'],['GR','Greece'],['GL','Greenland'],['GD','Grenada'],['GP','Guadeloupe'],
  ['GT','Guatemala'],['GG','Guernsey'],['GN','Guinea'],['GW','Guinea-Bissau'],['GY','Guyana'],
  ['HT','Haiti'],['HN','Honduras'],['HK','Hong Kong SAR'],['HU','Hungary'],['IS','Iceland'],
  ['IN','India'],['ID','Indonesia'],['IR','Iran'],['IQ','Iraq'],['IE','Ireland'],
  ['IM','Isle of Man'],['IL','Israel'],['IT','Italy'],['JM','Jamaica'],['JP','Japan'],
  ['JE','Jersey'],['JO','Jordan'],['KZ','Kazakhstan'],['KE','Kenya'],['KI','Kiribati'],
  ['XK','Kosovo'],['KW','Kuwait'],['KG','Kyrgyzstan'],['LA','Laos'],['LV','Latvia'],
  ['LB','Lebanon'],['LS','Lesotho'],['LR','Liberia'],['LY','Libya'],['LI','Liechtenstein'],
  ['LT','Lithuania'],['LU','Luxembourg'],['MO','Macao SAR'],['MG','Madagascar'],['MW','Malawi'],
  ['MY','Malaysia'],['MV','Maldives'],['ML','Mali'],['MT','Malta'],['MQ','Martinique'],
  ['MR','Mauritania'],['MU','Mauritius'],['MX','Mexico'],['MD','Moldova'],['MC','Monaco'],
  ['MN','Mongolia'],['ME','Montenegro'],['MS','Montserrat'],['MA','Morocco'],['MZ','Mozambique'],
  ['MM','Myanmar'],['NA','Namibia'],['NR','Nauru'],['NP','Nepal'],['NL','Netherlands'],
  ['NC','New Caledonia'],['NZ','New Zealand'],['NI','Nicaragua'],['NE','Niger'],['NG','Nigeria'],
  ['MK','North Macedonia'],['NO','Norway'],['OM','Oman'],['PK','Pakistan'],['PS','Palestinian Territories'],
  ['PA','Panama'],['PG','Papua New Guinea'],['PY','Paraguay'],['PE','Peru'],['PH','Philippines'],
  ['PL','Poland'],['PT','Portugal'],['QA','Qatar'],['RE','Reunion'],['RO','Romania'],
  ['RU','Russia'],['RW','Rwanda'],['WS','Samoa'],['SM','San Marino'],['SA','Saudi Arabia'],
  ['SN','Senegal'],['RS','Serbia'],['SC','Seychelles'],['SL','Sierra Leone'],['SG','Singapore'],
  ['SX','Sint Maarten'],['SK','Slovakia'],['SI','Slovenia'],['SB','Solomon Islands'],['SO','Somalia'],
  ['ZA','South Africa'],['KR','South Korea'],['SS','South Sudan'],['ES','Spain'],['LK','Sri Lanka'],
  ['KN','St. Kitts & Nevis'],['LC','St. Lucia'],['VC','St. Vincent & Grenadines'],['SD','Sudan'],['SR','Suriname'],
  ['SE','Sweden'],['CH','Switzerland'],['SY','Syria'],['TW','Taiwan'],['TJ','Tajikistan'],
  ['TZ','Tanzania'],['TH','Thailand'],['TL','Timor-Leste'],['TG','Togo'],['TO','Tonga'],
  ['TT','Trinidad & Tobago'],['TN','Tunisia'],['TR','Turkiye'],['TM','Turkmenistan'],['TC','Turks & Caicos Islands'],
  ['TV','Tuvalu'],['UG','Uganda'],['UA','Ukraine'],['AE','United Arab Emirates'],['GB','United Kingdom'],
  ['US','United States'],['UY','Uruguay'],['UZ','Uzbekistan'],['VU','Vanuatu'],['VA','Vatican City'],
  ['VE','Venezuela'],['VN','Vietnam'],['VG','British Virgin Islands'],['YE','Yemen'],['ZM','Zambia'],
  ['ZW','Zimbabwe']
];
function populateCountrySelect() {
  var sel = document.getElementById('addr-country');
  if (!sel || sel.options.length) return;
  COUNTRIES.forEach(function(c) {
    var opt = document.createElement('option');
    opt.value = c[0];
    opt.textContent = c[1];
    sel.appendChild(opt);
  });
  sel.value = 'US';
}
function countryNameToCode(name) {
  if (!name) return 'US';
  var lower = name.trim().toLowerCase();
  var match = COUNTRIES.find(function(c) { return c[1].toLowerCase() === lower || c[0].toLowerCase() === lower; });
  return match ? match[0] : 'US';
}
var appState = { customer: null, currentOrder: null, ordersPageInfo: null };
document.addEventListener('DOMContentLoaded', async function() {
  populateCountrySelect();
  var params = new URLSearchParams(window.location.search);
  var code = params.get('code');
  var ostate = params.get('state');
  if (code) {
    var savedState = sessionStorage.getItem('oauth_state');
    if (ostate !== savedState) { alert('Security error. Please try again.'); initiateLogin(); return; }
    try {
      var tokens = await exchangeCodeForToken(code);
      var expiresAt = Date.now() + (tokens.expires_in * 1000);
      localStorage.setItem('ca_access_token', tokens.access_token);
      localStorage.setItem('ca_refresh_token', tokens.refresh_token || '');
      localStorage.setItem('ca_id_token', tokens.id_token || '');
      localStorage.setItem('ca_expires_at', expiresAt.toString());
      window.history.replaceState({}, '', window.location.pathname);
    } catch(e) { initiateLogin(); return; }
  }
  var token = getAccessToken();
  if (!token) { initiateLogin(); return; }
  document.getElementById('loading-screen').style.display = 'none';
  document.getElementById('account-screen').style.display = 'flex';
  await loadCustomer();
});
function switchTab(tabName, navEl) {
  document.querySelectorAll('.ca-content').forEach(function(el) { el.classList.remove('active'); el.classList.add('hidden'); });
  var target = document.getElementById('tab-' + tabName);
  if (target) { target.classList.add('active'); target.classList.remove('hidden'); }
  if (navEl) { document.querySelectorAll('.ca-nav-item').forEach(function(el) { el.classList.remove('active'); }); navEl.classList.add('active'); }
  if (tabName === 'orders' && appState.customer) {
    document.getElementById('ca-page-title').textContent = 'Your orders';
  } else if (tabName === 'profile') {
    document.getElementById('ca-page-title').textContent = 'Profile';
  } else if (tabName === 'addresses') {
    document.getElementById('ca-page-title').textContent = 'Saved addresses';
  }
  document.querySelector('.ca-sidebar').classList.remove('open');
}
async function loadCustomer() {
  try {
    var data = await caFetch(GET_CUSTOMER);
    if (!data) return;
    appState.customer = data.customer;
    var c = appState.customer;
    var initial = ((c.firstName || c.lastName || '?')[0]).toUpperCase();
    document.getElementById('ca-avatar').textContent = initial;
    document.getElementById('ca-name').textContent = (c.firstName || '') + ' ' + (c.lastName || '');
    document.getElementById('ca-email').textContent = (c.emailAddress && c.emailAddress.emailAddress) || '';
    var stats = c.orderStats.nodes;
    var totalSpent = stats.reduce(function(sum, o) { return sum + parseFloat(o.totalPrice.amount); }, 0);
    var currency = stats.length ? stats[0].totalPrice.currencyCode : 'USD';
    document.getElementById('stat-orders').textContent = stats.length;
    document.getElementById('stat-spent').textContent = formatMoney(totalSpent, currency);
    document.getElementById('stat-addresses').textContent = c.addresses.nodes.length;
    appState.ordersPageInfo = c.orders.pageInfo;
    renderOrders();
    prefillProfile();
    renderAddresses();
  } catch(e) { console.error('Failed to load customer:', e); }
}
function renderOrders() {
  document.getElementById('orders-loading').classList.add('hidden');
  var orders = appState.customer.orders.nodes;
  if (!orders.length) { document.getElementById('orders-empty').classList.remove('hidden'); return; }
  var listEl = document.getElementById('orders-list');
  listEl.classList.remove('hidden');
  listEl.innerHTML = orders.map(function(order) {
    var price = order.totalPrice;
    var cls = statusClass(order.fulfillmentStatus, order.financialStatus);
    var label = statusLabel(order.fulfillmentStatus, order.financialStatus);
    var firstItem = order.lineItems.nodes[0];
    var itemCount = order.lineItems.nodes.reduce(function(sum, i) { return sum + i.quantity; }, 0);
    var itemLabel = itemCount === 1 ? '1 item' : itemCount + ' items';
    var imgHtml = firstItem && firstItem.image && firstItem.image.url
      ? '<img src="' + firstItem.image.url + '" alt="" style="width:44px;height:44px;border-radius:8px;object-fit:cover;flex-shrink:0;" />'
      : '<div style="width:44px;height:44px;border-radius:8px;background:#F0EEE8;display:flex;align-items:center;justify-content:center;font-size:18px;flex-shrink:0;">📦</div>';
    return '<div class="order-row" onclick="openOrderDetail(\'' + order.id + '\')">' +
      imgHtml +
      '<div style="flex:1;min-width:0;">' +
        '<div class="order-row-name">' + (firstItem ? firstItem.title : 'Order') + '</div>' +
        '<div class="order-row-meta">' + order.name + ' · ' + formatDate(order.processedAt) + ' · ' + itemLabel + '</div>' +
      '</div>' +
      '<div style="text-align:right;flex-shrink:0;">' +
        '<div class="order-row-price">' + formatMoney(price.amount, price.currencyCode) + '</div>' +
        '<span class="status-badge status--' + cls + '">' + label + '</span>' +
      '</div>' +
    '</div>';
  }).join('');
  var loadMoreWrap = document.getElementById('orders-load-more-wrap');
  if (appState.ordersPageInfo && appState.ordersPageInfo.hasNextPage) {
    loadMoreWrap.classList.remove('hidden');
  } else {
    loadMoreWrap.classList.add('hidden');
  }
}
async function loadMoreOrders() {
  if (!appState.ordersPageInfo || !appState.ordersPageInfo.hasNextPage) return;
  var loadMoreWrap = document.getElementById('orders-load-more-wrap');
  var btn = loadMoreWrap.querySelector('button');
  var originalText = btn ? btn.textContent : '';
  if (btn) { btn.disabled = true; btn.textContent = 'Loading...'; }
  try {
    var data = await caFetch(LOAD_MORE_ORDERS, { after: appState.ordersPageInfo.endCursor });
    if (!data) return;
    appState.customer.orders.nodes = appState.customer.orders.nodes.concat(data.customer.orders.nodes);
    appState.ordersPageInfo = data.customer.orders.pageInfo;
    renderOrders();
  } catch(e) {
    console.error('Failed to load more orders:', e);
  } finally {
    if (btn) { btn.disabled = false; btn.textContent = originalText || 'Load more orders'; }
  }
}
function openOrderDetail(orderId) {
  var order = appState.customer.orders.nodes.find(function(o) { return o.id === orderId; });
  if (!order) return;
  appState.currentOrder = order;
  document.querySelectorAll('.ca-content').forEach(function(el) { el.classList.remove('active'); el.classList.add('hidden'); });
  document.querySelectorAll('.ca-nav-item').forEach(function(el) { el.classList.remove('active'); });
  var detailEl = document.getElementById('tab-order-detail');
  detailEl.classList.add('active'); detailEl.classList.remove('hidden');
  document.getElementById('ca-page-title').textContent = order.name;
  var el = document.getElementById('order-detail-content');
  var price = order.totalPrice;
  var subtotal = order.subtotal;
  var shipping = order.totalShipping;
  var tax = order.totalTax;
  var cls = statusClass(order.fulfillmentStatus, order.financialStatus);
  var label = statusLabel(order.fulfillmentStatus, order.financialStatus);
  var fulfillment = order.fulfillments && order.fulfillments.nodes && order.fulfillments.nodes[0];
  var tracking = fulfillment && fulfillment.trackingInformation && fulfillment.trackingInformation[0];
  var trackingHtml = tracking
    ? '<div class="tracking-banner"><div><div class="tracking-label">Tracking · ' + (tracking.company || '') + '</div><div class="tracking-num">' + tracking.number + '</div></div>' + (tracking.url ? '<a class="btn btn--outline" href="' + tracking.url + '" target="_blank" rel="noopener" style="margin-left:auto">Track package</a>' : '') + '</div>'
    : '';
  var lineItems = order.lineItems.nodes.map(function(item) {
    var imgHtml = item.image && item.image.url ? '<img class="line-item-img" src="' + item.image.url + '" alt="' + (item.image.altText || '') + '" />' : '<div class="line-item-img-placeholder">📦</div>';
    var variantLabel = item.variantTitle && item.variantTitle !== 'Default Title' ? item.variantTitle : '';
    var unitPrice = item.price ? formatMoney(item.price.amount, item.price.currencyCode) : '';
    var lineTotal = item.price ? formatMoney(parseFloat(item.price.amount) * item.quantity, item.price.currencyCode) : '';
    return '<div class="line-item">' + imgHtml + '<div class="line-item-info"><div class="line-item-name">' + item.title + '</div>' + (variantLabel ? '<div class="line-item-variant">' + variantLabel + '</div>' : '') + '<div class="line-item-variant">Qty ' + item.quantity + (unitPrice ? ' · ' + unitPrice + ' ea' : '') + '</div></div><div class="line-item-price">' + lineTotal + '</div></div>';
  }).join('');
  var addr = order.shippingAddress;
  var addrText = addr ? [addr.firstName + ' ' + addr.lastName, addr.address1, addr.city + ', ' + addr.province + ' ' + addr.zip].filter(Boolean).join(', ') : 'N/A';
  var vatNum = appState.customer.metafield && appState.customer.metafield.value;
  var vatRow = vatNum ? '<div class="totals-row"><span>VAT / Tax No.</span><span>' + vatNum + '</span></div>' : '';
  el.innerHTML =
    '<div class="order-meta-grid">' +
    '<div class="order-meta-cell"><div class="order-meta-label">Order date</div><div class="order-meta-value">' + formatDate(order.processedAt) + '</div></div>' +
    '<div class="order-meta-cell"><div class="order-meta-label">Status</div><div class="order-meta-value"><span class="status-badge status--' + cls + '">' + label + '</span></div></div>' +
    '<div class="order-meta-cell"><div class="order-meta-label">Ship to</div><div class="order-meta-value" style="font-size:0.8rem;font-weight:500">' + addrText + '</div></div>' +
    '</div>' + trackingHtml +
    '<div class="line-items-table">' + lineItems + '</div>' +
    '<div class="order-totals">' +
    '<div class="totals-row"><span>Subtotal</span><span>' + (subtotal ? formatMoney(subtotal.amount, subtotal.currencyCode) : '—') + '</span></div>' +
    '<div class="totals-row"><span>Shipping</span><span>' + (shipping ? formatMoney(shipping.amount, shipping.currencyCode) : '—') + '</span></div>' +
    '<div class="totals-row"><span>Tax</span><span>' + (tax ? formatMoney(tax.amount, tax.currencyCode) : '—') + '</span></div>' +
    vatRow +
    '<div class="totals-row total"><span>Total</span><span>' + formatMoney(price.amount, price.currencyCode) + '</span></div>' +
    '</div>';
}
function prefillProfile() {
  var c = appState.customer;
  document.getElementById('p-first').value = c.firstName || '';
  document.getElementById('p-last').value  = c.lastName  || '';
  document.getElementById('p-email').value = (c.emailAddress && c.emailAddress.emailAddress) || '';
  document.getElementById('p-phone').value = (c.phoneNumber && c.phoneNumber.phoneNumber) || '';
  document.getElementById('p-vat').value   = (c.metafield && c.metafield.value) || '';
}
async function saveProfile() {
  var alertEl = document.getElementById('profile-alert');
  clearAlert(alertEl);
  var vatValue = document.getElementById('p-vat').value.trim();
  var input = {
    firstName: document.getElementById('p-first').value.trim(),
    lastName:  document.getElementById('p-last').value.trim()
  };
  try {
    var data = await caFetch(UPDATE_CUSTOMER, { input: input });
    if (!data) return;
    var errs = data.customerUpdate.userErrors;
    if (errs.length) { showAlert(alertEl, errs.map(function(e) { return e.message; }).join(', '), 'error'); return; }
    var metaData = await caFetch(UPDATE_METAFIELD, { metafields: [{ ownerId: appState.customer.id, namespace: 'custom', key: 'vat_tax_number', value: vatValue, type: 'single_line_text_field' }] });
    if (metaData) {
      var metaErrs = metaData.metafieldsSet.userErrors;
      if (metaErrs.length) { showAlert(alertEl, metaErrs.map(function(e) { return e.message; }).join(', '), 'error'); return; }
    }
    await loadCustomer();
    showAlert(alertEl, 'Your profile has been saved.', 'success');
  } catch(e) { showAlert(alertEl, e.message || 'Failed to save profile.', 'error'); }
}
function renderAddresses() {
  var listEl = document.getElementById('addresses-list');
  var addresses = appState.customer.addresses.nodes;
  var defaultId = appState.customer.defaultAddress && appState.customer.defaultAddress.id;
  if (!addresses.length) {
    listEl.innerHTML = '<div class="empty-state"><div class="empty-icon">📍</div><p class="empty-title">No saved addresses</p><p class="empty-sub">Add an address to speed up checkout.</p></div>';
    return;
  }
  listEl.innerHTML = addresses.map(function(addr) {
    var isDefault = addr.id === defaultId;
    var name = [addr.firstName, addr.lastName].filter(Boolean).join(' ');
    var lines = [addr.company, addr.address1, addr.address2, [addr.city, addr.province, addr.zip].filter(Boolean).join(', '), addr.country].filter(Boolean);
    return '<div class="address-card ' + (isDefault ? 'is-default' : '') + '">' +
      '<div>' + (isDefault ? '<div class="address-default-badge">Default</div>' : '') +
      '<div class="address-text"><div class="address-name">' + name + '</div>' + lines.map(function(l) { return '<div>' + l + '</div>'; }).join('') + '</div></div>' +
      '<div class="address-actions">' +
      (!isDefault ? '<button class="btn btn--ghost" style="font-size:0.8rem;padding:0.4rem 0.75rem" onclick="setDefaultAddress(\'' + addr.id + '\')">Set default</button>' : '') +
      '<button class="btn btn--ghost" style="font-size:0.8rem;padding:0.4rem 0.75rem" onclick="openAddressForm(\'' + addr.id + '\')">Edit</button>' +
      '<button class="btn btn--danger" onclick="deleteAddress(\'' + addr.id + '\')">Remove</button>' +
      '</div></div>';
  }).join('');
}
function openAddressForm(addrId) {
  var modal = document.getElementById('address-modal');
  ['addr-id','addr-first','addr-last','addr-company','addr-1','addr-2','addr-city','addr-zip','addr-province','addr-phone'].forEach(function(id) { document.getElementById(id).value = ''; });
  document.getElementById('addr-country').value = 'US';
  document.getElementById('addr-default').checked = false;
  clearAlert(document.getElementById('address-alert'));
  if (addrId) {
    document.getElementById('modal-title').textContent = 'Edit address';
    var addr = appState.customer.addresses.nodes.find(function(a) { return a.id === addrId; });
    if (addr) {
      document.getElementById('addr-id').value = addr.id;
      document.getElementById('addr-first').value = addr.firstName || '';
      document.getElementById('addr-last').value = addr.lastName || '';
      document.getElementById('addr-company').value = addr.company || '';
      document.getElementById('addr-1').value = addr.address1 || '';
      document.getElementById('addr-2').value = addr.address2 || '';
      document.getElementById('addr-city').value = addr.city || '';
      document.getElementById('addr-zip').value = addr.zip || '';
      document.getElementById('addr-province').value = addr.province || '';
      document.getElementById('addr-country').value = countryNameToCode(addr.country);
      document.getElementById('addr-default').checked = addr.id === (appState.customer.defaultAddress && appState.customer.defaultAddress.id);
    }
  } else {
    document.getElementById('modal-title').textContent = 'Add address';
  }
  modal.classList.remove('hidden'); modal.classList.add('active');
}
function closeAddressModal(event) {
  if (event && event.target !== document.getElementById('address-modal')) return;
  document.getElementById('address-modal').classList.add('hidden');
  document.getElementById('address-modal').classList.remove('active');
}
async function saveAddress() {
  var alertEl = document.getElementById('address-alert');
  clearAlert(alertEl);
  var id = document.getElementById('addr-id').value;
  var address = {
    firstName: document.getElementById('addr-first').value.trim(),
    lastName: document.getElementById('addr-last').value.trim(),
    company: document.getElementById('addr-company').value.trim() || null,
    address1: document.getElementById('addr-1').value.trim(),
    address2: document.getElementById('addr-2').value.trim() || null,
    city: document.getElementById('addr-city').value.trim(),
    zip: document.getElementById('addr-zip').value.trim(),
    zoneCode: document.getElementById('addr-province').value.trim(),
    territoryCode: document.getElementById('addr-country').value,
    phoneNumber: document.getElementById('addr-phone').value.trim() || null,
  };
  var setDefault = document.getElementById('addr-default').checked;
  if (!address.firstName || !address.lastName || !address.address1 || !address.city || !address.zip) { showAlert(alertEl, 'Please fill in all required fields.', 'error'); return; }
  try {
    var data, errs;
    if (id) {
      data = await caFetch(UPDATE_ADDRESS, { addressId: id, address: address, defaultAddress: setDefault });
      errs = (data && data.customerAddressUpdate && data.customerAddressUpdate.userErrors) || [];
    } else {
      data = await caFetch(CREATE_ADDRESS, { address: address });
      errs = (data && data.customerAddressCreate && data.customerAddressCreate.userErrors) || [];
    }
    if (errs.length) { showAlert(alertEl, errs.map(function(e) { return e.message; }).join(', '), 'error'); return; }
    closeAddressModal();
    await loadCustomer();
    renderAddresses();
  } catch(e) { showAlert(alertEl, e.message || 'Failed to save address.', 'error'); }
}
async function deleteAddress(id) {
  if (!confirm('Remove this address?')) return;
  try { await caFetch(DELETE_ADDRESS, { addressId: id }); await loadCustomer(); renderAddresses(); } catch(e) { alert(e.message); }
}
async function setDefaultAddress(id) {
  try { await caFetch(UPDATE_ADDRESS, { addressId: id, address: {}, defaultAddress: true }); await loadCustomer(); renderAddresses(); } catch(e) { alert(e.message); }
}
function printReceipt() {
  if (!appState.currentOrder) return;
  var order = appState.currentOrder;
  var cfg = SHOPIFY_CONFIG;
  var price = order.totalPrice;
  var subtotal = order.subtotal;
  var shipping = order.totalShipping;
  var tax = order.totalTax;
  var label = statusLabel(order.fulfillmentStatus, order.financialStatus);
  var addr = order.shippingAddress;
  var shipLines = addr ? [[addr.firstName, addr.lastName].filter(Boolean).join(' '), addr.address1, addr.address2, [addr.city, addr.province, addr.zip].filter(Boolean).join(', '), addr.country].filter(Boolean) : ['No shipping address'];
  var c = appState.customer;
  var vatNum = c.metafield && c.metafield.value;
  var billLines = [[c.firstName, c.lastName].filter(Boolean).join(' '), c.emailAddress && c.emailAddress.emailAddress, c.phoneNumber && c.phoneNumber.phoneNumber].filter(Boolean);
  var lineItemsHtml = order.lineItems.nodes.map(function(item) {
    var unitPrice = item.price ? formatMoney(item.price.amount, item.price.currencyCode) : '';
    var lineTotal = item.price ? formatMoney(parseFloat(item.price.amount) * item.quantity, item.price.currencyCode) : '';
    var variantLabel = item.variantTitle && item.variantTitle !== 'Default Title' ? item.variantTitle : '';
    return '<tr><td><div>' + item.title + '</div>' + (variantLabel ? '<div style="font-size:8.5pt;color:#777;margin-top:2px">' + variantLabel + '</div>' : '') + '</td><td>' + unitPrice + '</td><td style="text-align:center">' + item.quantity + '</td><td>' + lineTotal + '</td></tr>';
  }).join('');
  var fulfillment = order.fulfillments && order.fulfillments.nodes && order.fulfillments.nodes[0];
  var tracking = fulfillment && fulfillment.trackingInformation && fulfillment.trackingInformation[0];
  var trackingRow = tracking ? '<tr><td colspan="3" style="color:#888;font-size:8.5pt">Tracking: ' + (tracking.company || '') + ' ' + tracking.number + '</td><td></td></tr>' : '';
  var vatReceiptRow = vatNum ? '<div class="tr"><span>VAT / Tax No.</span><span>' + vatNum + '</span></div>' : '';
  var styles = 'body{font-family:Arial,sans-serif;font-size:12pt;color:#000;margin:0;padding:0}.receipt{max-width:680px;margin:0 auto;padding:40px}.rh{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:3px solid #1B2B4B;padding-bottom:20px;margin-bottom:24px}.sn{font-size:20pt;font-weight:700;margin-bottom:6px;color:#1B2B4B}.sd{font-size:9pt;color:#555;line-height:1.6}.rm{text-align:right;font-size:9pt;line-height:1.7}.ml{font-weight:700;text-transform:uppercase;font-size:7.5pt;color:#888}.mv{font-size:10pt;font-weight:600;color:#000}.rt{font-size:13pt;font-weight:700;text-transform:uppercase;letter-spacing:.08em;color:#1B2B4B;margin-bottom:16px}.addr{display:flex;gap:40px;margin-bottom:28px}.ab{flex:1}.al{font-size:7.5pt;font-weight:700;text-transform:uppercase;color:#888;margin-bottom:6px}.at{font-size:10pt;line-height:1.6;color:#222}table{width:100%;border-collapse:collapse;margin-bottom:24px}th{font-size:8pt;font-weight:700;text-transform:uppercase;color:#888;padding:8px 10px;border-bottom:1px solid #ccc;text-align:left}th:last-child,td:last-child{text-align:right}td{padding:10px;font-size:10pt;color:#222;border-bottom:1px solid #eee;vertical-align:top}.tots{margin-left:auto;width:280px;margin-bottom:32px}.tr{display:flex;justify-content:space-between;padding:5px 0;font-size:10pt;color:#444;border-bottom:1px solid #eee}.grand{font-size:12pt;font-weight:700;color:#000;border-bottom:2px solid #1B2B4B;border-top:1px solid #1B2B4B;padding:8px 0}.foot{text-align:center;font-size:8.5pt;color:#888;border-top:1px solid #ddd;padding-top:16px;margin-top:12px;line-height:1.8}.st{display:inline-block;font-size:8pt;font-weight:700;text-transform:uppercase;padding:3px 8px;border:1.5px solid #1B2B4B;border-radius:4px;color:#1B2B4B}.vat-badge{display:inline-block;background:#EEF4FA;color:#1B2B4B;font-size:8pt;font-weight:700;padding:3px 8px;border-radius:4px;margin-top:4px}';
  var logoHtml = cfg.logoUrl ? '<img src="' + cfg.logoUrl + '" alt="' + cfg.storeName + '" style="max-height:60px;max-width:220px;margin-bottom:12px;display:block;" />' : '';
var body = '<div class="receipt"><div class="rh"><div>' + logoHtml + '<div class="sn">' + cfg.storeName + '</div><div class="sd">' + [cfg.storeAddress, cfg.storePhone, cfg.storeEmail, cfg.storeWebsite].filter(Boolean).join('<br>') + '</div></div><div class="rm"><div class="ml">Order</div><div class="mv">' + order.name + '</div><br><div class="ml">Date</div><div class="mv">' + formatDate(order.processedAt) + '</div><br><div class="ml">Status</div><div class="mv"><span class="st">' + label + '</span></div></div></div><div class="rt">Order Receipt</div><div class="addr"><div class="ab"><div class="al">Bill to</div><div class="at">' + billLines.join('<br>') + (vatNum ? '<br><span class="vat-badge">VAT: ' + vatNum + '</span>' : '') + '</div></div><div class="ab"><div class="al">Ship to</div><div class="at">' + shipLines.join('<br>') + '</div></div></div><table><thead><tr><th style="width:50%">Item</th><th>Unit price</th><th style="text-align:center">Qty</th><th>Total</th></tr></thead><tbody>' + lineItemsHtml + trackingRow + '</tbody></table><div class="tots"><div class="tr"><span>Subtotal</span><span>' + (subtotal ? formatMoney(subtotal.amount, subtotal.currencyCode) : '—') + '</span></div><div class="tr"><span>Shipping</span><span>' + (shipping ? formatMoney(shipping.amount, shipping.currencyCode) : '—') + '</span></div><div class="tr"><span>Tax</span><span>' + (tax ? formatMoney(tax.amount, tax.currencyCode) : '—') + '</span></div>' + vatReceiptRow + '<div class="tr grand"><span>Total</span><span>' + formatMoney(price.amount, price.currencyCode) + '</span></div></div><div class="foot">Thank you for your order!<br>' + (cfg.storeWebsite ? cfg.storeWebsite + ' &nbsp;·&nbsp; ' : '') + (cfg.storeEmail ? cfg.storeEmail + ' &nbsp;·&nbsp; ' : '') + (cfg.storePhone || '') + '</div></div>';
  var win = window.open('', '_blank', 'width=800,height=600');
  win.document.write('<!DOCTYPE html><html><head><meta charset="UTF-8"><title>Receipt ' + order.name + '</title><style>' + styles + '</style></head><body>' + body + '</body></html>');
  win.document.close();
  win.focus();
  setTimeout(function() { win.print(); }, 500);
}
function formatMoney(amount, currencyCode) { return new Intl.NumberFormat('en-US', { style: 'currency', currency: currencyCode || 'USD' }).format(parseFloat(amount)); }
function formatDate(iso) { return new Date(iso).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }); }
function statusClass(fulfillment, financial) {
  if (financial === 'REFUNDED') return 'refunded';
  if (fulfillment === 'FULFILLED') return 'fulfilled';
  if (fulfillment === 'PARTIALLY_FULFILLED') return 'unfulfilled';
  if (financial === 'PENDING') return 'pending';
  return 'unfulfilled';
}
function statusLabel(fulfillment, financial) {
  if (financial === 'REFUNDED') return 'Refunded';
  if (fulfillment === 'FULFILLED') return 'Fulfilled';
  if (fulfillment === 'PARTIALLY_FULFILLED') return 'Partially fulfilled';
  if (financial === 'PENDING') return 'Pending';
  return 'Processing';
}
function showAlert(el, msg, type) { el.textContent = msg; el.className = 'alert alert--' + (type || 'error'); el.classList.remove('hidden'); }
function clearAlert(el) { el.textContent = ''; el.classList.add('hidden'); }
